/** MedSyncIQ brand red — used for all status tags app-wide */
export const BRAND_RED = "#E4002B";

export const BRAND_TAG_STYLE = {
  color: BRAND_RED,
  background: "#FFF0F3",
  border: "#FFB3C0",
} as const;

export const BRAND_TAG_STYLE_SOLID = {
  color: "#FFFFFF",
  background: BRAND_RED,
  border: BRAND_RED,
} as const;

/** @deprecated Use BRAND_TAG_STYLE — kept for imports that reference variants */
export type StatusVariant = "success" | "warning" | "error" | "info" | "neutral";

export const STATUS_VARIANT_STYLES = {
  success: BRAND_TAG_STYLE,
  warning: BRAND_TAG_STYLE,
  error: BRAND_TAG_STYLE,
  info: BRAND_TAG_STYLE,
  neutral: BRAND_TAG_STYLE,
};

export function resolveStatusVariant(_status: string): StatusVariant {
  return "neutral";
}